import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Favicon from 'react-favicon';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import Loading from './components/Loading';
import { API_HOST } from './consts';
import MainSection from './containers/global/MainSection';
import { ThemeContext } from './contexts/ThemeContext';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import Login from './pages/Login';
import LoginRedirect from './pages/LoginRedirect';
import TokenLogin from './pages/TokenLogin';
import defaultTheme from './theme/DefaultTheme';
import withTracker from './withTracker';

const App = () => {
  const [loadingTheme, setLoadingTheme] = useState(true);
  const [theme, setTheme] = useState({});
  const fetchTheme = async () => {
    try {
      const response = await axios.get(`${API_HOST}/themes/`);
      setTheme({
        ...defaultTheme,
        ...response.data.theme,
      });
      setLoadingTheme(false);
    } catch (e) {
      setLoadingTheme(false);
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  if (loadingTheme) {
    return <Loading />;
  }

  return (
    <BrowserRouter>
      <ThemeContext.Provider value={theme}>
        <ThemeProvider theme={theme}>
          <div>
            <Favicon url={theme.favicon} />
            <ToastContainer autoClose={10000} />
            <Switch>
              <Route path="/login" component={withTracker(Login)} />
              <Route
                path="/login-redirect"
                component={withTracker(LoginRedirect)}
              />
              <Route
                path="/token-login/:token"
                component={withTracker(TokenLogin)}
              />
              <Route
                path="/forgot-password"
                component={withTracker(ForgotPassword)}
              />
              <Route
                path="/password-reset/:token"
                component={withTracker(ChangePassword)}
              />
              <MainSection />
            </Switch>
          </div>
        </ThemeProvider>
      </ThemeContext.Provider>
    </BrowserRouter>
  );
};

export default App;
